import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import instaIcon from "Assets/images/reportIntaIcon.png"
import phoneIcon from "Assets/images/reportPhoneIcon.png"
import clickIcon from "Assets/images/reportClickIcon.png"

const styles = StyleSheet.create({
    page: {
        color: "#000",
        padding: 20,
        backgroundColor: '#ffffff',
        fontFamily: 'Proxima Nova',
    },
    fontBold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'bold'
    },
    fontSemibold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'semibold'
    },
    fontLight: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'light'
    },
    container: {
        padding: '0 40px 0 40px',
    },
    border: {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        marginBottom: "10px"
    },
    headerRow: {
        flexDirection: 'row',
        alignItems: "flex-end",
        justifyContent: 'space-between',
        marginBottom: 20,
        padding: '0 40px 0 0',
    },
    row: {
        display: "flex",
        flexDirection: "row"
    },
    logo: {
        width: 127,
    },
    headerTitle: {
        textTransform: "uppercase",
        fontSize: 11,
        textAlign: 'center',
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 16,
        textAlign: 'center',
        marginTop: 5,
        color: "#93278F"
    },
    text: {
        fontSize: 12,
    },
    mainHeading: {
        fontSize: 10,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
    },
    subHeading: {
        fontSize: 7,
        fontWeight: 'semibold',
    },
    para: {
        fontSize: 8,
        fontWeight: 300
    },
    section: {
        marginTop: 10,
    },
    halfCol: {
        width: '50%',
        paddingRight: 10,
        marginBottom: 10,
    },
    fullCol: {
        width: '100%',
        paddingRight: 10,
        marginBottom: 10,
    },
    footer: {
        position: 'absolute',
        bottom: 15,
        left: 0,
        right: 0,
        // textAlign: 'center',
        // fontSize: 10,
        // color: 'grey',
        padding: '0 20px 0 60px',
        height: 60,
        // marginBottom: 20,
        // marginTop: 20,
        // height: 30
    },
});

export const PdfFooter = ({ data, type = "therapist" }) => {

    console.log('type of user', data)

    return (
        <View style={{ ...styles.footer }} fixed>
            <View style={styles.border}></View>
            <View>
                <View style={{ ...styles.row, justifyContent: "space-between", marginTop: "5px" }}>
                    <View style={{ gap: "4px" }}>
                        <View style={{ ...styles.row, alignItems: "center", justifyContent: "space-between", gap: "4px" }}>
                            <Text style={{ ...styles.para, ...styles.fontSemibold }}>
                                KHAN COMMUNICATION SERVICES
                            </Text>
                            <View style={{ ...styles.row, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={phoneIcon} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    (780)-440-3251
                                </Text>
                            </View>
                        </View>
                        <View style={{ ...styles.row, alignItems: "center", justifyContent: "space-between", gap: "10px" }}>
                            <View style={{ ...styles.row, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={instaIcon} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    @khancommservices
                                </Text>
                            </View>
                            <View style={{ ...styles.row, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={clickIcon} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    www.khancommunicationservices.com
                                </Text>
                            </View>
                        </View>
                    </View>
                    {
                        type == "therapist" ?
                            <>
                                {/* <View>
                                    <View style={{ ...styles.row, gap: "2px" }}>
                                        <Text style={{ ...styles.para, ...styles.fontSemibold }}>CLIENT ID:</Text>
                                        <Text style={{ ...styles.para }}>{data?.clientId}</Text>
                                    </View>
                                </View> */}
                                <View style={{ gap: "5px" }}>
                                    <View style={{ ...styles.row, gap: "2px" }}>
                                        <Text style={{ ...styles.para, ...styles.fontSemibold }}>Name:</Text>
                                        <Text style={{ ...styles.para }}>{data?.lastname && `${data?.lastname}, `}{data?.firstname || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.row, gap: "2px", justifyContent: "flex-end" }}>
                                        <Text style={{ ...styles.para, ...styles.fontSemibold, textAlign: "right" }}>DOB:</Text>
                                        <Text style={{ ...styles.para, textAlign: "right" }}>{data?.dob || ""}</Text>
                                    </View>
                                </View>
                            </> :
                            <>
                                <View style={{ gap: "5px" }}>
                                    {/* <View style={{ ...styles.row, gap: "2px" }}>
                                        <Text style={{ ...styles.para, ...styles.fontSemibold }}>TEACHER ID:</Text>
                                        <Text style={{ ...styles.para }}>{data?.teacherId}</Text>
                                    </View> */}
                                </View>
                                <View style={{ gap: "5px" }}>
                                    <View style={{ ...styles.row, gap: "2px" }}>
                                        <Text style={{ ...styles.para, ...styles.fontSemibold }}>Grade:</Text>
                                        <Text style={{ ...styles.para }}>{data?.report_grade || ""}</Text>
                                    </View>
                                    <View style={{ ...styles.row, gap: "2px", justifyContent: "flex-end" }}>
                                        <Text style={{ ...styles.para, ...styles.fontSemibold, textAlign: "right" }}>School:</Text>
                                        <Text style={{ ...styles.para, textAlign: "right" }}>{data?.schoolName || ""}</Text>
                                    </View>
                                </View>
                            </>
                    }
                </View>
            </View>
        </View>
    )
}
